var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!isNaN(_vm.data.value))?_c('v-progress-linear',{staticStyle:{"border-radius":"6px"},attrs:{"value":_vm.data.value,"color":"secondary","height":"25"}},[_c('strong',{staticClass:"text-white"},[_vm._v(" "+_vm._s(Math.ceil(_vm.data.value))+"% ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }